import Checkbox from 'components/checkbox';
import InputField from 'components/fields/InputField';
import { useEffect, useState } from 'react';

const BatchInfo = ({ handleChange, formData, setDisable }) => {
  const [errors, setErrors] = useState([]);
  const [batch, setBatch] = useState({
    batchNumber: '',
    startDate: '',
    endDate: '',
    fees: '',
    daySchedules: [], // new array to hold day + time
  });

  const dayOptions = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  useEffect(() => {
    const newErrors = [];
    if (formData.batches.length === 0) {
      newErrors.push('Please add at least one batch.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [formData.batches, setDisable]);

  const handleAddBatch = () => {
    console.log(
      batch.daySchedules,
      'batch.daySchedules',
      batch.daySchedules.some((d) => !d.startTime || !d.endTime)
    );
    if (
      !batch.batchNumber ||
      !batch.startDate ||
      !batch.endDate ||
      !batch.fees ||
      batch.daySchedules.length === 0 ||
      batch.daySchedules.some((d) => !d.startTime || !d.endTime)
    ) {
      setErrors((prev) => [
        ...prev,
        'Please fill in all fields, including day-wise times and fees.',
      ]);
      return;
    }

    const newBatches = [...formData.batches, batch];
    handleChange({
      target: {
        name: 'batches',
        value: newBatches,
      },
    });

    setBatch({
      batchNumber: '',
      startDate: '',
      endDate: '',
      fees: '',
      daySchedules: [],
    });
    setErrors([]);

    console.log(batch.daySchedules, 'batch.daySchedules');
  };

  const handleRemoveBatch = (index) => {
    const newBatches = formData.batches.filter((_, i) => i !== index);
    handleChange({
      target: {
        name: 'batches',
        value: newBatches,
      },
    });
  };

  const toggleDay = (day) => {
    const updated = [...batch.daySchedules];

    const index = updated.findIndex((d) => d.day === day);
    if (index > -1) {
      updated.splice(index, 1); // remove day if unchecking
    } else {
      updated.push({ day, startTime: '', endTime: '' });
    }

    setBatch({ ...batch, daySchedules: updated });
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Batch Information
      </h4>
      <div className="mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
        <InputField
          extra="mb-3"
          label="Batch Number"
          type="text"
          name="batchNumber"
          value={batch.batchNumber}
          onChange={(e) => setBatch({ ...batch, batchNumber: e.target.value })}
          maxLength={2}
        />
        <InputField
          extra="mb-3"
          label="Fees"
          type="text"
          name="fees"
          value={batch.fees}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              setBatch({ ...batch, fees: value });
            }
          }}
          maxLength={20}
        />

        <InputField
          extra="mb-3"
          label="Start Date"
          type="date"
          name="startDate"
          value={batch.startDate}
          onChange={(e) => setBatch({ ...batch, startDate: e.target.value })}
        />
        <InputField
          extra="mb-3"
          label="End Date"
          id="endDate"
          type="date"
          onChange={(e) => setBatch({ ...batch, endDate: e.target.value })}
          value={batch.endDate}
          min={batch.startDate}
        />

        <div className="mb-3 w-[540px] text-sm">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Days and Time
          </label>
          <div className="mt-2 grid grid-cols-5 gap-3">
            {dayOptions.map((day) => {
              const isSelected = batch.daySchedules.find((d) => d.day === day);
              return (
                <label
                  key={day}
                  className="col-span-1 flex items-center space-x-2"
                >
                  <Checkbox
                    value={day}
                    checked={!!isSelected}
                    onChange={() => toggleDay(day)}
                    extra="mr-1"
                  />
                  <span>{day}</span>
                </label>
              );
            })}
          </div>

          <div className="mt-4 space-y-3">
            {batch.daySchedules.map((item, idx) => (
              <div key={item.day} className="flex items-center gap-4">
                <div className="w-24 font-medium">{item.day}</div>
                <InputField
                  type="time"
                  label=""
                  extra="w-[140px]" // optional: controls width
                  value={item.startTime}
                  onChange={(e) => {
                    const updated = [...batch.daySchedules];
                    updated[idx].startTime = e.target.value;
                    setBatch({ ...batch, daySchedules: updated });
                  }}
                />
                <InputField
                  type="time"
                  label=""
                  extra="w-[140px]"
                  value={item.endTime}
                  onChange={(e) => {
                    const updated = [...batch.daySchedules];
                    updated[idx].endTime = e.target.value;
                    setBatch({ ...batch, daySchedules: updated });
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <button
        onClick={handleAddBatch}
        className="mt-4 rounded bg-blue-500 px-4 py-2 text-white"
      >
        Add Batch
      </button>

      <div className="mt-4">
        <h5 className="font-bold">Added Batches:</h5>
        {formData.batches.map((b, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-between md:flex-row"
          >
            <p>
              {`Batch ${b.batchNumber}: ${b.startDate} - ${b.endDate}, Fees: ${b.fees}`}
            </p>
            <button
              onClick={() => handleRemoveBatch(index)}
              className="text-red-500"
            >
              Remove
            </button>
          </div>
        ))}
      </div>

      {errors.length > 0 && (
        <div className="mt-4 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default BatchInfo;
